﻿/* global PhotoSwipe, PhotoSwipeUI_Default */

/**
  * The code in the PhotoSwiper class is adapted from https://photoswipe.com/documentation/getting-started.html,
  * below the "How to build an array of slides from a list of links" heading.
  */

/**
 * The swiper will add click event handlers to all gallery selector and fullscreen capable elements
 * in the DOM. The event handlers will display the associated image(s) in a fullscreen viewer and
 * allow browsing the images.
 */
export class PhotoSwiper {
  constructor(galleriesSelector, fullScreenCapableSelector, photoSwipeLoadPromise) {
    this.galleriesSelector = galleriesSelector;
    this.fullScreenCapableSelector = fullScreenCapableSelector;
    /* This is a script load promise which allows us to wait for the script (containing the
     * PhotoSwipe library) to load before we're using it. */
    this.photoSwipeLoadPromise = photoSwipeLoadPromise;
    this.galleryIdAttr = 'data-pswp-uid';
    this.galleryHistoryAttr = 'data-history'; // on the element containing the galleriesSelector
    this.pswpBgAttr = 'data-pswp-bg';

    this.pswp__bg = document.querySelector('.pswp__bg');
    this.galleries = [];
    this.fullScreenCapables = [];
    this.refresh();
  }

  elementExists(element, allElements) {
    for (var i = 0, l = allElements.length; i < l; i++) {
      if (element === allElements[i])
        return true;
    }
    return false;
  }

  /**
   * This method allows users to refresh the galleries if the DOM is modified after the initial
   * creation of this swiper. */
  refresh() {
    let galleryIndex = this.galleries.length; // 1-based
    const galleries = document.querySelectorAll(this.galleriesSelector);
    for (let i = 0, l = galleries.length; i < l; i++) {
      if (!this.elementExists(galleries[i], this.galleries)) {
        galleries[i].setAttribute(this.galleryIdAttr, galleryIndex + 1);
        galleries[i].onclick = event => this.handleGalleryClick(event);
        this.galleries.push(galleries[i]);
        galleryIndex++;
      }
    }

    const fullScreenCapables = document.querySelectorAll(this.fullScreenCapableSelector);
    for (let i = 0, l = fullScreenCapables.length; i < l; i++) {
      if (!this.elementExists(fullScreenCapables[i], this.fullScreenCapables)) {
        fullScreenCapables[i].setAttribute(this.galleryIdAttr, galleryIndex + 1);
        let clickTarget = null;
        if (this.hasClass(fullScreenCapables[i], 'custom-zoom-target')) {
          /* We're going to handle clicks associated with the element which has a 'zoom-target' class.
            * Since we assume fullScreenCapables[i] is an img, the zoom target cannot be child of fullScreenCapables[i].
            * Let's use the next sibling instead (if present). */
          clickTarget = fullScreenCapables[i].nextElementSibling;
        } else {
          clickTarget = fullScreenCapables[i];
        }
        if (clickTarget) {
          clickTarget.onclick = event => this.handleFullScreenCapableClick(event);
        } else {
          console.log('Custom zoom target not found');
        }
        this.fullScreenCapables.push(galleries[i]);
        galleryIndex++;
      }
    }

    if (this.galleries.length > 0 || fullScreenCapables.length > 0) {
      // Parse URL and open photo swiper if it contains #&pid=3&gid=1
      const hashData = this.parseUrlHashValue();
      if (hashData.pid && (typeof hashData.gid != 'undefined')) {
        /* TODO: This code will break if the swiper was updated after the initial creation because
         * there might be galleries after the fullScreenCapables. */
        const gid = hashData.gid - 1;
        const isGallery = gid < this.galleries.length;
        const element = isGallery ? this.galleries[gid] : fullScreenCapables[gid - this.galleries.length];
        /*await*/ this.openPhotoSwipe(hashData.pid, element, true, true, isGallery);
      }
    }
  }

  // Helper: find the nearest parent element of el
  closest(el, fn) {
    return el && (fn(el) ? el : this.closest(el.parentNode, fn));
  }

  // Helper: returns true if cls is defined on the class attribute of element
  hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }

  // Helper: parse picture index and gallery index from the URL's hash value (#&pid=1&gid=2)
  parseUrlHashValue() {
    const hash = window.location.hash.substring(1);
    const params = {};
    if (hash.length < 5) {
      return params;
    }
    const vars = hash.split('&');
    for (let i = 0; i < vars.length; i++) {
      if (vars[i]) {
        var pair = vars[i].split('=');
        if (pair.length >= 2) {
          params[pair[0]] = pair[1];
        }
      }
    }
    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }
    return params;
  }

  /**
   * If isGallery is true, then galleryParentElement should be the immediate parent of the list of
   * elements containing the 'gallery-item' class.
   * If isGallery is false, then galleryParentElement should be the img element to display fullscreen.
   */
  createItemObjects(galleryParentElement, isGallery) {
    const galleryItems = isGallery
      ? $(galleryParentElement).find('.gallery-item:not(.isotope-hidden)').get()
      : [galleryParentElement];
    const itemObjects = [];
    for (let i = 0; i < galleryItems.length; i++) {
      const galleryItem = galleryItems[i]; // <div class="gallery-item">

      // include only element nodes
      if (galleryItem.nodeType !== 1) {
        continue;
      }

      const linkEl = isGallery
        ? galleryItem.querySelector('a') // <a> element
        : galleryItem;

      if (!linkEl) {
        // If we're in a gallery, but no 'a' tag was found under the gallery item, then assume this
        // item should not be included in the array of elements for full screen view.
        continue;
      }

      // Create item object
      let itemObject;
      if ($(linkEl).data('type') == 'video') {
        itemObject = {
          html: $(linkEl).data('video')
        };
      } else {
        const size = linkEl.getAttribute('data-size').split('x');
        const href = isGallery ? 'href' : 'data-href';
        itemObject = {
          src: linkEl.getAttribute(href),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10)
        };
      }

      if (galleryItem.children.length > 1) {
        // <figcaption> content
        itemObject.title = $(galleryItem).find('.caption').html();
      }

      let image = null;
      if (!isGallery) {
        image = linkEl;
      } else if (linkEl.children.length > 0) {
        // Use the child <img>'s src as the source to be displayed while loading the large fullscreen image
        image = linkEl.children[0];
      }
      if (image !== null) {
        itemObject.msrc = image.currentSrc || image.getAttribute('src');
      }

      itemObject.el = galleryItem; // save link to element for getThumbBoundsFn
      itemObjects.push(itemObject);
    }
    return itemObjects;
  }

  /**
   * Main Photoswipe kick-off function (on click or url hash value).
   * @param {any} index index of the gallery item to display.
   * @param {any} galleryParentElement If isGallery is true, then galleryParentElement should be
   * the immediate parent of the list of elements containing the 'gallery-item' class. If isGallery
   * is false, then galleryParentElement should be the img element to display fullscreen.
   * @param {any} isGallery If true, then we are displaying a list of photos/images. Otherwise a
   * single photo/image is displayed.
   */
  async openPhotoSwipe(index, galleryParentElement, disableAnimation, fromURL, isGallery, background) {
    if (this.pswp__bg) {
      if (background) {
        this.pswp__bg.style.background = background;
      } else {
        this.pswp__bg.style.background = null;
      }
    }

    const items = this.createItemObjects(galleryParentElement, isGallery);
    const historyAttr = galleryParentElement.getAttribute(this.galleryHistoryAttr);
    const allowHistory = (typeof historyAttr === 'undefined') || historyAttr === null ||
      historyAttr === 'true' || historyAttr === '1';
    const options = {
      closeOnScroll: false,
      // Define gallery UID (for the URL of the gallery items)
      galleryUID: galleryParentElement.getAttribute(this.galleryIdAttr),
      history: allowHistory,
      getThumbBoundsFn: index => {
        /* Should return the rect of the image which is maximixed for the purpose of animation.
         * See Options -> getThumbBoundsFn section of documentation for more info. */
        const image = isGallery ? items[index].el.getElementsByTagName('img')[0] : items[index].el;
        if (image) {
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          const rect = image.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      }
    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (!allowHistory) {
        return;
      }
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (let j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes are 1-based
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // Exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    const pswpElement = document.querySelectorAll('.pswp')[0];
    if (!pswpElement) {
      throw Error('The Photoswipe elements have not been added to the DOM');
    }

    /* If we have a script load promise, and the PhotoSwipe class is undefined still, then use the
     * promise to wait for the script (containing the PhotoSwipe library) to load. */
    const isPromise = this.photoSwipeLoadPromise instanceof Promise;
    const photoSwipeType = typeof PhotoSwipe;
    if (photoSwipeType === 'undefined' && isPromise) {
      await this.photoSwipeLoadPromise;
    }

    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();

    gallery.listen('beforeChange', function() {
      $('.pswp__video').removeClass('active');
      $('.pswp__video').each(function() {
        if (!$(this).hasClass('active')) {
          $(this).attr('src', $(this).attr('src'));
        }
      });
    });

    gallery.listen('close', function() {
      $('.pswp__video').each(function() {
        $(this).attr('src', $(this).attr('src'));
      });
    });
  }

  /* 11/24/18: I've added code to allow a custom element to be clicked instead of the photo.
   * This is needed when using the gallery to display product finishes for selection by the user.
   * A click on the photo should select the finish instead of showing the fullscreen image.
   * If the element referencing this click handler (e.g. ".gallery-wrapper") has the
   * ".custom-zoom-target" class, then child elements with the ".zoom-target" class can be
   * clicked instead. */
  async handleGalleryClick(event) {
    event = event || window.event;
    // eTarget is the ultimate clicked element.
    const eTarget = event.target || event.srcElement;
    if (this.hasClass(eTarget, 'do-not-zoom')) {
      return; // Allow default handling and return
    }
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    // e.currentTarget is the element this event handler has been attached to (e.g. the .gallery-wrapper element).
    const useCustomClick = this.hasClass(event.currentTarget, 'custom-zoom-target');
    let isCustomClick = false;
    if (useCustomClick) {
      const zoomTarget = this.closest(eTarget, el => this.hasClass(el, 'zoom-target'));
      if (zoomTarget) {
        isCustomClick = true;
      }
    }
    let clickedGalleryItem = null;
    if (!useCustomClick || isCustomClick) {
      clickedGalleryItem = this.closest(eTarget, el => this.hasClass(el, 'gallery-item'));
    }
    if (!clickedGalleryItem) {
      return;
    }

    /* Find index of clicked item by looping through all gallery items. Alternatively, you might
     * define index via data-attribute. */
    const clickedGallery = clickedGalleryItem.closest(this.galleriesSelector);
    const galleryItems = $(clickedGallery).find('.gallery-item:not(.isotope-hidden)').get();
    let nodeIndex = 0;
    let clickedIndex;
    for (let i = 0; i < galleryItems.length; i++) {
      if (galleryItems[i].nodeType === 1) {
        if (galleryItems[i] === clickedGalleryItem) {
          clickedIndex = nodeIndex;
          break;
        }
        nodeIndex++;
      }
    }

    if (clickedIndex >= 0) {
      const clickedImage = this.closest(eTarget, el => el.nodeName == 'IMG');
      const background = clickedImage ? clickedImage.getAttribute(this.pswpBgAttr) : null;
      await this.openPhotoSwipe(clickedIndex, clickedGallery, false, false, true, background);
    }
    return;
  }

  async handleFullScreenCapableClick(event) {
    event = event || window.event;
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    // eTarget is the ultimate clicked element.
    const eTarget = event.target || event.srcElement;

    /* We need to handle 2 scenarios:
     * 1. No custom zoom target has been defined --> The click is on an img.fullscreen-capable
     * 2. A custom zoom target has been defined --> The click is on the img's next sibling element,
     *    in which case the 'custom-zoom-target' is defined on the image, and the 'zoom-target' is
     *    defined on the sibling. The click will be on the sibling.
     */
    // e.currentTarget is the element this event handler has been attached to (e.g. the .fullscreen-capable or .zoom-target element).
    let clickedImage = null;
    const useCustomClick = this.hasClass(event.currentTarget, 'zoom-target');
    if (useCustomClick) {
      clickedImage = event.currentTarget.previousElementSibling;
      if (clickedImage !== null && !this.hasClass(clickedImage, 'custom-zoom-target')) {
        clickedImage = null;
      }
    } else {
      clickedImage = this.closest(eTarget, el => this.hasClass(el, 'fullscreen-capable'));
    }
    if (!clickedImage) {
      return;
    }

    const background = clickedImage.getAttribute(this.pswpBgAttr);

    await this.openPhotoSwipe(0, clickedImage, false, false, false, background);
    return false;
  }
}